(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.announcement__slide'));
      if (this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.index = 0;
      this.interval = Number(this.dataset.interval) || 5000;
      this.start();

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      if (this.timer) return;
      this.timer = window.setInterval(() => this.advance(), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    advance() {
      const current = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      const next = this.slides[this.index];
      current.hidden = true;
      current.classList.remove('is-active');
      next.hidden = false;
      next.classList.add('is-active');
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-qty-change]');
        if (!trigger) return;
        event.preventDefault();
        this.update(trigger.dataset.line, trigger.dataset.qtyChange);
      });
    }

    async update(line, quantity) {
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: Number(line),
            quantity: Number(quantity),
            sections: 'cart-drawer'
          })
        });

        const data = await response.json();
        document.dispatchEvent(new CustomEvent('ruq:cart:updated', { detail: data }));
      } catch (error) {
        window.location.href = window.Shopify.routes.root + 'cart';
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var query = window.matchMedia('(min-width: 990px)');

    function sync() {
      document.querySelectorAll('.footer__disclosure').forEach(function (node) {
        node.open = query.matches ? true : node.open;
        if (query.matches) node.setAttribute('open', '');
      });
    }

    query.addEventListener('change', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.onScroll = this.onScroll.bind(this);
      this.observe();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    observe() {
      this.overlay = this.classList.contains('header--overlay');
      this.hero = document.querySelector('.section--under-header');
    }

    onScroll() {
      this.observe();

      if (!this.overlay) {
        this.classList.remove('is-solid');
        return;
      }

      const limit = this.hero
        ? this.hero.offsetTop + this.hero.offsetHeight - this.offsetHeight * 1.6
        : window.innerHeight * 0.55;

      this.classList.toggle('is-solid', window.scrollY > limit);
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-qty-change]').forEach((link) => {
    link.addEventListener('click', async (event) => {
      event.preventDefault();

      const body = {
        line: Number(link.dataset.line),
        quantity: Number(link.dataset.quantity)
      };

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });

        if (!response.ok) throw new Error('cart');
        window.location.reload();
      } catch (error) {
        window.location.href = link.href;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-sort-form]').forEach((form) => {
    form.addEventListener('change', () => {
      const select = form.querySelector('select');
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.reel = this.querySelector('.gal__reel');
      this.frames = Array.from(this.querySelectorAll('[data-frame]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.desktop = window.matchMedia('(min-width: 990px)');

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(Number(thumb.dataset.thumb)));
      });

      if (this.reel && this.dots.length) {
        this.reel.addEventListener('scroll', () => this.syncDots(), { passive: true });
      }

      this.addEventListener('ruq:gallery:go', (event) => this.show(event.detail.index));
    }

    syncDots() {
      if (this.desktop.matches) return;
      const width = this.reel.clientWidth || 1;
      const index = Math.round(this.reel.scrollLeft / width);
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    show(index) {
      this.frames.forEach((frame) => {
        frame.classList.toggle('is-active', Number(frame.dataset.frame) === index);
      });

      this.thumbs.forEach((thumb) => {
        const match = Number(thumb.dataset.thumb) === index;
        thumb.classList.toggle('is-active', match);
        thumb.setAttribute('aria-selected', match ? 'true' : 'false');
      });

      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));

      if (!this.desktop.matches && this.reel) {
        const frame = this.frames[index];
        if (frame) this.reel.scrollTo({ left: frame.offsetLeft - this.reel.offsetLeft, behavior: 'smooth' });
      }
    }
  }

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.querySelector('[data-qty-down]').addEventListener('click', () => this.step(-1));
      this.querySelector('[data-qty-up]').addEventListener('click', () => this.step(1));
    }

    step(delta) {
      const next = Math.max(1, (parseInt(this.input.value, 10) || 1) + delta);
      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.dataset.variants);
      } catch (error) {
        this.variants = [];
      }

      this.form = this.closest('form');
      this.addEventListener('change', () => this.onChange());
    }

    chosen() {
      return Array.from(this.querySelectorAll('.pdp__radio:checked'))
        .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
        .map((input) => input.value);
    }

    onChange() {
      const values = this.chosen();

      this.querySelectorAll('[data-option-value]').forEach((node, index) => {
        if (values[index]) node.textContent = values[index];
      });

      this.render(
        this.variants.find((candidate) =>
          candidate.options.every((value, index) => value === values[index])
        )
      );
    }

    render(variant) {
      const strings = window.ruqStrings || {};
      const button = this.form && this.form.querySelector('[data-add-button]');
      const label = button && button.querySelector('[data-add-text]');
      const input = this.form && this.form.querySelector('[data-variant-input]');

      if (!variant) {
        if (button) button.disabled = true;
        if (label) label.textContent = strings.unavailable || '';
        return;
      }

      if (input) input.value = variant.id;
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? strings.addToCart : strings.soldOut;

      if (window.ruqMoney) {
        const money = window.ruqMoney(variant.price);
        document.querySelectorAll('[data-price] .pdp__price-now, [data-buybar-price]').forEach((node) => {
          node.textContent = money;
        });
      }

      if (variant.featured_media) {
        const gallery = document.querySelector('product-gallery');
        if (gallery) {
          gallery.dispatchEvent(
            new CustomEvent('ruq:gallery:go', { detail: { index: variant.featured_media.position - 1 } })
          );
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);

  /* Yapışkan satın alma çubuğu: ana buton görüş alanından çıkınca belirir. */
  (function () {
    const bar = document.querySelector('[data-buybar]');
    const anchor = document.querySelector('.pdp__buy');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    bar.hidden = false;

    new IntersectionObserver(
      (entries) => {
        const gone = !entries[0].isIntersecting;
        bar.classList.toggle('is-open', gone);
        document.body.classList.toggle('has-buybar', gone);
      },
      { rootMargin: '0px 0px -120px 0px' }
    ).observe(anchor);
  })();

  /* Büyütme */
  (function () {
    const dialog = document.querySelector('[data-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const stage = dialog.querySelector('[data-lightbox-stage]');

    document.querySelectorAll('[data-zoom]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const source = trigger.querySelector('img');
        if (!source) return;

        const clone = source.cloneNode(true);
        clone.removeAttribute('sizes');
        clone.removeAttribute('class');
        clone.loading = 'eager';

        stage.replaceChildren(clone);
        dialog.showModal();
      });
    });

    dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target === stage) dialog.close();
    });
    dialog.addEventListener('close', () => stage.replaceChildren());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.querySelectorAll('[data-recommendations]').forEach(async (holder) => {
    try {
      const response = await fetch(holder.dataset.url);
      if (!response.ok) return;

      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const fresh = parsed.querySelector('.rel');

      if (fresh && fresh.querySelector('.rel__grid')) {
        holder.replaceWith(fresh);
      } else {
        holder.remove();
      }
    } catch (error) {
      holder.remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.dotsHolder = this.querySelector('[data-dots]');
      this.items = Array.from(this.querySelectorAll('.reviews__item'));

      if (!this.viewport || !this.dotsHolder || this.items.length < 2) return;

      this.dots = [];
      this.perPage = 0;
      this.page = 0;
      this.still = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Number(this.dataset.interval) || 0;

      this.build();

      this.viewport.addEventListener(
        'scroll',
        () => {
          window.cancelAnimationFrame(this.frame);
          this.frame = window.requestAnimationFrame(() => this.sync());
        },
        { passive: true }
      );

      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this.viewport);
      }

      this.bindDrag();
      this.bindAutoplay();
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
      if (this.watcher) this.watcher.disconnect();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    /* --- Fare ile sürükleyerek kaydırma (dokunmatikte tarayıcı zaten yapıyor) --- */

    bindDrag() {
      this.viewport.addEventListener('pointerdown', (event) => {
        this.stop();
        if (event.pointerType === 'touch' || event.button !== 0) return;

        this.dragging = true;
        this.startX = event.clientX;
        this.startLeft = this.viewport.scrollLeft;
        this.viewport.setPointerCapture(event.pointerId);
        this.viewport.classList.add('is-free', 'is-grabbing');
      });

      this.viewport.addEventListener('pointermove', (event) => {
        if (!this.dragging) return;
        event.preventDefault();
        this.viewport.scrollLeft = this.startLeft - (event.clientX - this.startX);
      });

      const release = (event) => {
        if (!this.dragging) {
          this.start();
          return;
        }

        this.dragging = false;
        this.viewport.classList.remove('is-grabbing');

        if (this.viewport.hasPointerCapture(event.pointerId)) {
          this.viewport.releasePointerCapture(event.pointerId);
        }

        // Önce sayfa başına yerleştir, snap'i ancak oturduktan sonra geri aç.
        this.go(Math.min(Math.round(this.nearest() / this.perPage), Math.max(this.dots.length - 1, 0)));
        window.clearTimeout(this.settle);
        this.settle = window.setTimeout(() => this.viewport.classList.remove('is-free'), 450);
        this.start();
      };

      this.viewport.addEventListener('pointerup', release);
      this.viewport.addEventListener('pointercancel', release);
      this.viewport.addEventListener('dragstart', (event) => event.preventDefault());
    }

    /* --- Otomatik geçiş --- */

    bindAutoplay() {
      if (!this.interval || this.still.matches) return;

      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch') this.stop();
      });

      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'touch') this.start();
      });

      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);

      // Sayfanın görünmeyen bir yerinde boşuna dönmesin.
      if (window.IntersectionObserver) {
        this.watcher = new IntersectionObserver((entries) => {
          this.onScreen = entries[0].isIntersecting;
          this.start();
        });
        this.watcher.observe(this);
      } else {
        this.onScreen = true;
        this.start();
      }

      // Tema düzenleyicide blok seçilince durdur, bırakılınca devam et.
      document.addEventListener('shopify:block:select', () => this.stop());
      document.addEventListener('shopify:block:deselect', () => this.start());
    }

    start() {
      this.stop();

      if (!this.interval || this.still.matches) return;
      if (this.dragging || document.hidden || this.onScreen === false) return;
      if (this.dots.length < 2) return;

      this.timer = window.setInterval(() => this.go((this.page + 1) % this.dots.length), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    visibleCount() {
      const width = this.items[0].getBoundingClientRect().width;
      if (!width) return 1;
      return Math.max(1, Math.round(this.viewport.clientWidth / width));
    }

    build() {
      const perPage = this.visibleCount();

      if (perPage === this.perPage) {
        this.sync();
        return;
      }

      this.perPage = perPage;
      this.dots = [];
      this.dotsHolder.textContent = '';

      const pages = Math.ceil(this.items.length / perPage);

      if (pages < 2) {
        this.dotsHolder.hidden = true;
        this.stop();
        return;
      }

      for (let page = 0; page < pages; page += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'reviews__dot';
        dot.setAttribute('aria-label', (this.dataset.dotLabel || '') + ' ' + (page + 1));
        dot.addEventListener('click', () => this.go(page));
        this.dotsHolder.appendChild(dot);
        this.dots.push(dot);
      }

      this.dotsHolder.hidden = false;
      this.sync();
      this.start();
    }

    go(page) {
      const item = this.items[Math.min(page * this.perPage, this.items.length - 1)];
      if (!item) return;

      this.viewport.scrollTo({ left: item.offsetLeft, behavior: this.still.matches ? 'auto' : 'smooth' });
    }

    nearest() {
      const left = this.viewport.scrollLeft;
      let index = 0;
      let shortest = Infinity;

      this.items.forEach((item, i) => {
        const distance = Math.abs(item.offsetLeft - left);
        if (distance < shortest) {
          shortest = distance;
          index = i;
        }
      });

      return index;
    }

    sync() {
      if (!this.dots.length) return;

      let page = Math.min(Math.floor(this.nearest() / this.perPage), this.dots.length - 1);

      if (this.viewport.scrollLeft + this.viewport.clientWidth >= this.viewport.scrollWidth - 2) {
        page = this.dots.length - 1;
      }

      this.page = page;

      this.dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === page ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('reviews-slider')) {
    customElements.define('reviews-slider', ReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
